import React from 'react';
import { Button } from '../ui/Button';
import { CheckIcon } from 'lucide-react';
import { useMetaPixel } from '../../hooks/useMetaPixel';
export function FinalCTA() {
  const {
    trackAddToCart
  } = useMetaPixel();
  const checkoutUrl = 'https://krove.lat//cart/40641678344321:1';
  const handleBuy = () => {
    trackAddToCart();
    window.location.href = checkoutUrl;
  };
  return <section className="py-16 md:py-24 bg-emerald-900 text-white text-center" data-id="element-9">
      <div className="container mx-auto px-4" data-id="element-10">
        <div className="max-w-3xl mx-auto" data-id="element-11">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-12">
            Empieza hoy. No el lunes.
          </h2>
          <p className="text-xl text-emerald-100 mb-10" data-id="element-13">
            Recupera tu ligereza y energía por menos de lo que cuesta una cena
            fuera.
          </p>

          <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 mb-10 border border-white/20" data-id="element-14">
            <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-8" data-id="element-15">
              <div className="text-left space-y-3" data-id="element-16">
                <div className="flex items-center" data-id="element-17">
                  <CheckIcon className="h-5 w-5 text-emerald-400 mr-3" data-id="element-18" />
                  <span data-id="element-19">Plan de 21 Días Completo</span>
                </div>
                <div className="flex items-center" data-id="element-20">
                  <CheckIcon className="h-5 w-5 text-emerald-400 mr-3" data-id="element-21" />
                  <span data-id="element-22">Menús y Recetas</span>
                </div>
                <div className="flex items-center" data-id="element-23">
                  <CheckIcon className="h-5 w-5 text-emerald-400 mr-3" data-id="element-24" />
                  <span data-id="element-25">Guía de Hábitos AM/PM</span>
                </div>
              </div>
              <div className="text-center md:text-right" data-id="element-26">
                <p className="text-sm text-emerald-200 line-through" data-id="element-27">
                  Valor Real: 80.000 COP
                </p>
                <p className="text-5xl font-bold text-white" data-id="element-28">23.999 COP</p>
              </div>
            </div>

            <Button size="xl" onClick={handleBuy} className="w-full md:w-auto bg-white text-emerald-900 hover:bg-emerald-50 shadow-xl" data-id="element-29">
              Acceso inmediato al PDF
            </Button>
          </div>

          <p className="text-sm text-emerald-300 opacity-80" data-id="element-30">
            Pago seguro con tarjeta o transferencia • Garantía de entrega
            inmediata
          </p>
        </div>
      </div>
    </section>;
}